import { render, staticRenderFns } from "./ListGuardiasPorDia.vue?vue&type=template&id=83d2f232&"
import script from "./ListGuardiasPorDia.vue?vue&type=script&lang=js&"
export * from "./ListGuardiasPorDia.vue?vue&type=script&lang=js&"
import style0 from "./ListGuardiasPorDia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports